import { render, staticRenderFns } from "./DatasetPanel.vue?vue&type=template&id=612e898b&scoped=true"
import script from "./DatasetPanel.vue?vue&type=script&lang=js"
export * from "./DatasetPanel.vue?vue&type=script&lang=js"
import style0 from "./DatasetPanel.vue?vue&type=style&index=0&id=612e898b&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e898b",
  null
  
)

export default component.exports